import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { getBatchFiles } from 'actions/batches/getBatchFiles';
import { hideDeleteFileModal } from './deleteFileModal';

export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';

function requestDeleteFile() {
  return {
    type: DELETE_FILE_REQUEST,
    isDeletingFile: true
  };
}

function receiveDeleteFile(deleteFileResponse) {
  return {
    type: DELETE_FILE_SUCCESS,
    isDeletingFile: false,
    deleteFileResponse
  };
}

function rejectDeleteFile() {
  return {
    type: DELETE_FILE_FAILURE,
    isDeletingFile: false
  };
}

export function deleteBatchFile(batchId, fileId, pageNumber, pageSize) {
  return (dispatch) => {
    dispatch(requestDeleteFile());

    const promise = () => ApiService
      .deleteBatchFile(batchId, fileId)
      .then((response) => {
        dispatch(receiveDeleteFile(response.data));
        dispatch(hideDeleteFileModal());
        return dispatch(getBatchFiles(batchId, pageNumber, pageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectDeleteFile, true));
        }
      });
    return promise();
  };
}
